import { Observable } from 'rxjs';
import { IncentiveProgramModel, OperationRateModel } from '../domain/incentive-program.model';

export abstract class IncentiveProgramRepository {
  abstract getIncentiveProgramDetails(): Observable<IncentiveProgramModel>;
  abstract getOperationRateDetails(): Observable<OperationRateModel>;
}
